import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBriefcase = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.5 8.375C7.5 8.58594 7.3125 8.75 7.125 8.75H4.875C4.66406 8.75 4.5 8.58594 4.5 8.375V7.25H0V10.625C0 11.2344 0.515625 11.75 1.125 11.75H10.875C11.4609 11.75 12 11.2344 12 10.625V7.25H7.5V8.375ZM10.875 2.75H9V1.625C9 1.03906 8.46094 0.5 7.875 0.5H4.125C3.51562 0.5 3 1.03906 3 1.625V2.75H1.125C0.515625 2.75 0 3.28906 0 3.875V6.5H12V3.875C12 3.28906 11.4609 2.75 10.875 2.75ZM7.875 2.75H4.125V1.625H7.875V2.75Z",
		fill: "#AA00FF"
	})]
});
const ForwardRef = forwardRef(SvgBriefcase);
export { ForwardRef as ReactComponent };
